import RouteNames from '../constants/route-names';

/**
 * Routes in Step workflow in order of appearance
 *
 * @type {string[]}
 */
const stepOrder = [
  RouteNames.AppointmentSchedule,
  RouteNames.AppointmentServices,
  RouteNames.AppointmentProperty,
  RouteNames.AppointmentCreateAccount,
  RouteNames.AppointmentSignIn,
  RouteNames.AppointmentContact,
  RouteNames.AppointmentSummary,
  RouteNames.AppointmentConfirmation,
];

/**
 * Retrieve index of a RouteName in the Step order by name
 *
 * @param {string} routeName - Name constant (RouteNames) of the Route to search for
 * @returns {number}
 */
const getStepIndexByRouteName = routeName => stepOrder.findIndex(x => x === routeName);

/**
 * Retrieve a Route in the Step order by index
 *
 * @param {number} stepIndex - Order index of Route to retrieve
 * @returns {string|null}
 */
const getStepByIndex = stepIndex => {
  if (stepIndex < 0 || stepOrder.length <= stepIndex) {
    return null;
  }
  return stepOrder[stepIndex];
};

/**
 * Redirect to next step if current step is not
 * at the end of the step order.
 *
 * @param {Route} currentRoute
 * @param {VueRouter} router
 */
const goToNextStep = (currentRoute, router) => {
  if (!currentRoute || !router) {
    return;
  }

  const { name } = currentRoute;
  const currentRouteIndex = getStepIndexByRouteName(name);
  if (currentRouteIndex < 0 || currentRouteIndex >= (stepOrder.length - 1)) {
    return;
  }

  const nextRoute = getStepByIndex(currentRouteIndex + 1);
  router.push({ name: nextRoute }).catch(() => {});
};

/**
 * Redirect to previous step if current step is not
 * at the beginning of the step order.
 *
 * @param {Route} currentRoute
 * @param {VueRouter} router
 */
const goToPreviousStep = (currentRoute, router) => {
  if (!currentRoute || !router) {
    return;
  }

  const { name } = currentRoute;
  const currentRouteIndex = getStepIndexByRouteName(name);
  if (currentRouteIndex <= 0) {
    return;
  }

  const previousRoute = getStepByIndex(currentRouteIndex - 1);
  router.push({ name: previousRoute }).catch(() => {});
};

/**
 * @param {string} appointmentId
 * @param {VueRouter} router
 */
const goToConfirmationStep = (appointmentId, router) => {
  router.push({
    name: RouteNames.AppointmentConfirmation,
    params: { appointmentId },
  }).catch(() => {});
};

/**
 * @param {VueRouter} router
 */
const goToContactStep = router => {
  router.push({ name: RouteNames.AppointmentContact }).catch(() => {});
};

/**
 * @param {VueRouter} router
 */
const goToCreateAccountStep = router => {
  router.push({ name: RouteNames.AppointmentCreateAccount }).catch(() => {});
};

/**
 * @param {VueRouter} router
 */
const goToPropertyStep = router => {
  router.push({ name: RouteNames.AppointmentProperty }).catch(() => {});
};

/**
 * @param {VueRouter} router
 */
const goToScheduleStep = router => {
  router.push({ name: RouteNames.AppointmentSchedule }).catch(() => {});
};

/**
 * @param {VueRouter} router
 */
const goToServicesStep = router => {
  router.push({ name: RouteNames.AppointmentServices }).catch(() => {});
};

/**
 * @param {VueRouter} router
 */
const goToSignInStep = router => {
  router.push({ name: RouteNames.AppointmentSignIn }).catch(() => {});
};

/**
 * @param {VueRouter} router
 */
const goToSummaryStep = router => {
  router.push({ name: RouteNames.AppointmentSummary }).catch(() => {});
};

export default {
  getStepByIndex,
  getStepIndexByRouteName,
  goToConfirmationStep,
  goToContactStep,
  goToCreateAccountStep,
  goToNextStep,
  goToPropertyStep,
  goToPreviousStep,
  goToScheduleStep,
  goToServicesStep,
  goToSignInStep,
  goToSummaryStep,
  stepOrder,
};
